import { Injectable } from '@angular/core';
import axios from 'axios';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AWSS3Service } from './aws.s3.service';
import { Observable } from 'rxjs';
import { AppConstants } from '../app.constants';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  // baseURL = 'https://api.virtuascript.net';
  baseURL = environment.apiUrl;

  user: any;
  constructor(
    private s3: AWSS3Service,
    private http: HttpClient,
    private constant: AppConstants,
    private authService: AuthService,

  ) {
    this.user = this.authService.getUser();
  }

  updateUserState() {
    this.user = this.authService.getUser();
  }

  async importCategory(key) {
    try {
      const getPresignedURL = await this.s3.generatePresignedURL(key, "getObject");
      const payload = { "signedURL": getPresignedURL, email: this.user.email };

      const response = await axios.post(`${this.baseURL}/masterfile/category/import`, payload,
        {
          headers: {
            "x-api-key": environment.apiKey
          }
        });
      return response;
    } catch (error) {
      throw { error: "Error while importing data: " + error };
    }
  }

  async getGroup(): Promise<Observable<any>> {
    const response = await this.http.post("/account/group", { sortBy: "name" })
    return response;
  }

  async addGroup(params: any) {
    const response = await this.http.post("/account/group/add", { ...params, email: this.user.email })
    return response;
  }

  async editGroup(params: any) {
    const response = await this.http.post("/account/group/update", { ...params, email: this.user.email })
    return response;
  }

  async deleteGroup(ids) {
    const response = await this.http.post("/account/group/delete", { ids, email: this.user.email })
    return response;
  }

  async export(): Promise<Observable<any>> {
    const response = this.http.post("/account/group/export", { email: this.user.email });
    return response;
  }

}
